
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype4On as ObiMosfetPtype4OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-4-on.js';
 
 
 

 
 export const ObiMosfetPtype4On = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-4-on',
   elementClass: ObiMosfetPtype4OnElement,
   events: {
     
   }
  });
 
 